var EMPTY = {};
export default function shallowEqual(c, d) {
  void 0 === c && (c = EMPTY), void 0 === d && (d = EMPTY);
  var e = Object.keys(c),
      f = Object.keys(d);
  return c === d || e.length === f.length && e.every(function (a) {
    return c[a] === d[a];
  });
}